import React, { useEffect, useRef } from 'react';
import './Proposito.css';

const Proposito = () => {
  const textRef  = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.1 }
    );
    if (textRef.current)  observer.observe(textRef.current);
    if (videoRef.current) observer.observe(videoRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="proposito-page">

      {/* ── HEADER ── */}
      <header className="proposito-header">
        <div className="proposito-header__inner">
          <h1 className="proposito-header__title">Nuestro Propósito</h1>
          <p className="proposito-header__subtitle">
            La visión y el compromiso que guían cada paso del programa
          </p>
        </div>
        <div className="proposito-header__bar" />
      </header>

      {/* ── CONTENIDO ── */}
      <section className="proposito-section">
        <div className="proposito-layout">

          {/* Texto */}
          <div ref={textRef} className="proposito-text-box fade-up">
            <p className="proposito-text">
              El camino de la psicología deportiva en nuestro país sigue creciendo, y hoy somos
              parte activa de ese desarrollo. Hemos iniciado una ruta que nos ha permitido
              compartir conocimiento, experiencia y metodología, siempre con un foco claro:
              acompañar al deportista en cada etapa de su proceso, tanto en el entrenamiento
              como en la competencia.
            </p>
            <p className="proposito-text">
              A través de nuestra metodología Mente Ganadora, hemos logrado construir una hoja
              de ruta clara y aplicada, que orienta al deportista en el camino que necesita
              recorrer para potenciar su rendimiento, su bienestar y su desarrollo integral.
              No se trata solo de competir mejor, sino de comprender el proceso mental que
              sostiene cada desafío deportivo.
            </p>
            <p className="proposito-text">
              Durante estos años, hemos sido parte del trabajo psicológico de la selección
              chilena, en sus distintas categorías formativas, lo que valida y respalda el
              enfoque que aplicamos día a día con nuestros deportistas. Esta experiencia nos
              ha permitido desarrollar una mirada transversal, entendiendo que cada camino
              es único, pero que todos comparten la necesidad de una base mental sólida.
            </p>
            <p className="proposito-text">
              Como director del programa, les doy la bienvenida a un espacio donde la
              psicología deportiva no es un complemento, sino un pilar fundamental en cada
              proyecto que se construye.
            </p>

            <div className="proposito-signature">
              <div className="proposito-signature__divider" />
              <p className="proposito-signature__name">Marco Garrido</p>
              <p className="proposito-signature__role">Director del Programa Mente Ganadora</p>
            </div>
          </div>

          {/* Video */}
          <div ref={videoRef} className="proposito-video-box fade-up fade-up--delay">
            <div className="proposito-video-wrap">
              <iframe
                src="https://www.youtube.com/embed/SPuqN40Y4D8"
                title="Programa Mente Ganadora"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Proposito;
